import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import { useParams } from "react-router";
import type { PersonResponse } from "~types/person";
import { useApi } from "./useApi";

type TransformFn<T> = (data: PersonResponse) => T;

export const useFetchPersons = <TTransformedData = PersonResponse>(
  urlParams: Record<string, string>,
  transformFn: TransformFn<TTransformedData> = (data) => data as unknown as TTransformedData,
  options: Omit<UseQueryOptions<TTransformedData>, "queryKey" | "queryFn"> = {},
) => {
  const request = useApi();

  const { organizationId, sport } = useParams();

  if (!organizationId || !sport) {
    throw new Error(
      `OrganizationId or sport not found in route params. organizationId: ${organizationId}, sport: ${sport}`,
    );
  }

  const params = new URLSearchParams(urlParams);

  return useQuery({
    queryKey: ["persons", sport, organizationId, params.toString()],
    queryFn: () =>
      request<PersonResponse>(`${sport}/o/${organizationId}/persons?${params.toString()}`).then(transformFn),
    ...options,
  });
};
